<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    modelValue: string;
    id: string;
    name?: string;
    label?: string;
    type?: string;
    showHidePass?: boolean;
    autocomplete?: string;
    placeholder?: string;
    hasError?: boolean;
    initialValue?: string;
    info?: string;
  }>(),
  {
    modelValue: '',
    name: '',
    label: '',
    type: 'text',
    showHidePass: false,
    autocomplete: 'off',
    placeholder: '',
    initialValue: '',
    hasError: false,
    info: '',
  },
);

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
}>();

const model = computed({
  get: () => props.modelValue,
  set: (val: string) => emit('update:modelValue', val),
});
</script>

<template>
  <BaseFormInput
    :id="id"
    v-model="model"
    :autocomplete="autocomplete"
    class="h-12 bg-[#0C1B44] rounded-[10px]"
    :has-error="hasError"
    :info="info"
    :initial-value="initialValue"
    :label="label"
    :name="name"
    :placeholder="placeholder || label"
    :show-hide-pass="showHidePass"
    :type="type"
    v-bind="$attrs"
  >
    <template #prepend>
      <slot name="prepend" />
    </template>
  </BaseFormInput>
</template>
